// Rolhiërarchie: per menusectie een primaire rol (de absolute minimumset); andere rollen hangen eronder en kunnen
// enkel samen met hun primaire rol toegekend worden. Administrator en Read-Only staan erbuiten.

/** Primaire rollen eerst, daarna hun onderliggende rollen (met `depth`), daarna de zelfstandige rollen. */
export function orderRolesAsTree(roles) {
  const byName = (a, b) => a.name.localeCompare(b.name, "nl");
  const primaries = roles.filter((r) => r.is_primary).sort(byName);
  const ids = new Set(primaries.map((r) => r.id));
  const result = [];
  primaries.forEach((primary) => {
    result.push({ ...primary, depth: 0 });
    roles
      .filter((r) => r.parent_role_id === primary.id)
      .sort(byName)
      .forEach((child) => result.push({ ...child, depth: 1 }));
  });
  roles
    .filter((r) => !r.is_primary && !ids.has(r.parent_role_id))
    .sort(byName)
    .forEach((r) => result.push({ ...r, depth: 0 }));
  return result;
}

/** Ids van de onderliggende rollen van een rol. */
export function childIdsOf(roleId, roles) {
  return roles.filter((r) => r.parent_role_id === roleId).map((r) => r.id);
}

/** Voegt bij elke rol zijn primaire rol toe (voor keuzes die als geheel gemaakt worden, zoals een uitnodiging). */
export function withParents(ids, roles) {
  const set = new Set(ids);
  roles.forEach((r) => {
    if (set.has(r.id) && r.parent_role_id) set.add(r.parent_role_id);
  });
  return [...set];
}

/** Haalt rollen uit een keuze, samen met de rollen die eronder hangen. */
export function withoutRolesAndChildren(ids, removeIds, roles) {
  const gone = new Set(removeIds);
  roles.forEach((r) => {
    if (r.parent_role_id && gone.has(r.parent_role_id)) gone.add(r.id);
  });
  return ids.filter((id) => !gone.has(id));
}
